import { Button, SvgIcon } from '@mui/material'
import  file from '../../../../assets/images/file.png'

import React from 'react'
import './Download.scss'
import Download from './Download'

const DownloadBtn = (props) => {
    const {label,link}=props
   const downloadLink=(link)=>{
    if(link||true){
        window.open(link, '_blank')
      }
   }
  return (
   <Button onClick={()=>{downloadLink(link)}} className='down_doc_btn'>
   <img src={file}></img>
   <div>{label}</div>
   </Button>
  )
}

export default DownloadBtn
